import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules  } from '@angular/router'; 
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
// import {} from './pages/support-ticket/view-support-ticket/view-support-ticket.module'
import { LoginComponent } from './pages/auth/login/login.component';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('../app/pages/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'home', 
    component: PagesComponent,
    children:[
      { path: 'dashboard', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' }  },          
      
      {
        path: 'user',
        loadChildren: () => import('../app/pages/user/view-user/view-user.module').then(m => m.ViewUserModule), data: { breadcrumb: 'Admin User Details' }
      },
 
  {
    path: 'appuser',
    loadChildren: () =>
      import('./pages/app-user/view-app-user/view-app-user.module').then((m) => m.AppUserViewModule), data: { breadcrumb: ' User ' }
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/auth/profile/profile.module').then((m) => m.ProfileModule), data: { breadcrumb: 'Profile' }
  },
 
  {
    path: 'useradminmaster',
    loadChildren: () =>
      import('./pages/User-Admin-Master/view-user-admin/view-user-admin.Module').then((m) => m.ViewUserAdminModule ), data: { breadcrumb: ' useradminmaster ' }
  },
  {
    path: 'adduseradminmaster',
    loadChildren: () =>
      import('./pages/User-Admin-Master/add-user-admin/add-user-admin.Module').then((m) => m.AddUserAdminModule ), data: { breadcrumb: ' useradminmaster ' }
   },
   {
    path: 'Collection',
    loadChildren: () =>
      import('./pages/Collection_Master/view-collection-master/View-Collection-Master.Module').then((m) => m.ViewCollectionModule ), data: { breadcrumb: ' Collection ' }
  },
  {
    path: 'Collection/add',
    loadChildren: () =>
    import('./pages/Collection_Master/view-collection-master/View-Collection-Master.Module').then((m) => m.ViewCollectionModule ), data: { breadcrumb: ' Collection' }
   },
  
   {
    path: 'usercollection',
    loadChildren: () =>
      import('./pages/User-Collection/view-user-collection/view-user-collection.Module').then((m) => m.ViewUserCollectionModule ), data: { breadcrumb: ' usercollection ' }
  },
  {
    path: 'addusercollection',
    loadChildren: () =>
      import('./pages/User-Collection/add-user-collection/add-user-collection.Module').then((m) => m.AddUserCollectionModule ), data: { breadcrumb: ' usercollection ' }
   },
  
   {
    path: 'userpost',
    loadChildren: () =>
      import('./pages/User-Collection/view-user-post/view-user-post.Module').then((m) => m.ViewUserPostModule ), data: { breadcrumb: ' userpost ' }
  },
 
  {
    path: 'userpostlist',
    loadChildren: () =>
      import('./pages/User-Post/view-user-post/view-user-post.Module').then((m) => m.ViewUserPostModule ), data: { breadcrumb: ' userpostlist ' }
  },
  {
    path: 'adduserpostlist',
    loadChildren: () =>
      import('./pages/User-Post/add-user-post/add-user-post.Module').then((m) => m.AddUserPostModule ), data: { breadcrumb: ' userpostlist ' }
   },
   {
    path: 'BlockPost',
    loadChildren: () =>
      import('./pages/spotlight-post/view-spotlight-post/view-spotlight-post.Module').then((m) => m.ViewSpotlightPostModule ), data: { breadcrumb: ' Block Post ' }
  },
  {
    path: 'AddPost',
    loadChildren: () =>
      import('./pages/spotlight-post/add-spotlight-post/add-spotlight-post.Module').then((m) => m.AddSpotlightPostModule ), data: { breadcrumb: ' AddPost ' }
   },
   {
    path: 'ViewPosts',
    loadChildren: () =>
      import('./pages/tattoo-artist/view-tattoo-artist-list/viewtattoo-artist.module').then((m) => m.viewTattooArtistModule ), data: { breadcrumb: ' ViewPosts ' }
  },
  {
    path: 'UserShow',
    loadChildren: () =>
      import('./pages/tattoo-artist/add-tattoo-artist/Addtattoo-artist.module').then((m) => m.AddTattooArtistModule ), data: { breadcrumb: ' User Show ' }
  },
  {
    path: 'BlockUserDetails',
    loadChildren: () =>
      import('./pages/tattoo-artist/helep-video-mng/helep-video-mng.module').then((m) => m.HelepVideoMngModule ), data: { breadcrumb: ' BlockUserDetails ' }
  },
  {
    path: 'BlockUsersView',
    loadChildren: () =>
      import('./pages/tattoo-artist/brand/brand.module').then((m) => m.BrandModule ), data: { breadcrumb: ' BlockUsersView ' }
  },
  {
    path: 'appuserNew',
    loadChildren: () =>
      import('./pages/tattoo-artist/add-user-new/add-user-new.module').then((m) => m.AddUserNewModule), data: { breadcrumb: ' User ' }
  },
 
  { path: 'user-subscription-list', loadChildren: () => import('./pages/user-subscription/user-subscription-list/user-subscription-list.module').then(m => m.UserSubscriptoinListModule), data: { breadcrumb: 'User Subscription' } },
  { path: 'user-subscription', loadChildren: () => import('./pages/user-subscription/create-user-subscription/create-user-subscription.module').then(m => m.UserSubscriptionModule), data: { breadcrumb: 'New User Subscription' } },
  { path: 'QuestionsData', loadChildren: () => import('./pages/tattoo-artist/ViewUser/ViewUser.module').then(m => m.ViewUserModule), data: { breadcrumb: 'QuestionsData' } },
  { path: 'UserData', loadChildren: () => import('./pages/tattoo-artist/UserData/UserData.module').then(m => m.UserDataModule), data: { breadcrumb: 'User Data' } },
  { path: 'Answers', loadChildren: () => import('./pages/tattoo-artist/Answers/Answers.module').then(m => m.AnswersModule), data: { breadcrumb: 'Answers' } },
  { path: 'Images', loadChildren: () => import('./pages/tattoo-artist/page4/page4.module').then(m => m.Page4Module), data: { breadcrumb: 'Images' } },
  { path: 'ImagesNew', loadChildren: () => import('./pages/tattoo-artist/page5/page5.module').then(m => m.Page5Module), data: { breadcrumb: 'ImagesNew' } },
  { path: 'Report', loadChildren: () => import('./pages/tattoo-artist/Report/Report.module').then(m => m.ReportModule), data: { breadcrumb: 'Report' } },
        {
    path:"change_Password",
    loadChildren:()=>import("./pages/tattoo-artist/change_Password/change_PasswordComponent.module").then((m)=>m.change_PasswordModule),data:{breadcrumb:"change_Password"}
  },
  /*
  {//import view module after exec
    path: 'groupdetails',
    loadChildren: () =>
      import('./pages/Group-Details/view-Group-Details/view-group-details.module').then((m) => m.viewGroupDetailModule), data: { breadcrumb: 'Getuser-Group-Detais' }
  },*/
  



  /*{


    http://localhost:4200/home/background/addbackgroundProvider/new
    path:'view-background',
    loadChildren:()=>
    import('./pages/background-providers/view-background-provider/view-background-provider.module')

  },*/

      { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } }
    
    ]
  },
  
  // { path: '**', component: NotFoundComponent }
   { path: '', redirectTo: '/admin/login', pathMatch: 'full' },
  
]; 

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      // relativeLinkResolution: 'IPLAdmin',
      // // useHash: true
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }